import React from 'react';

//Import Components
import ExamList from '../../components/exam/ExamList';


const CompetitiveLibrary = () => {
	
	return (
		<>
			<div className="row">
				<div className="exam_list_container" >
					<ExamList />
					adsfasfd
				</div>
			</div>
		</>
	)
}
export default CompetitiveLibrary;